import { render } from "./PosTicket.vue?vue&type=template&id=9373a9be&scoped=true"
import script from "./PosTicket.vue?vue&type=script&lang=js"
export * from "./PosTicket.vue?vue&type=script&lang=js"

import "./PosTicket.vue?vue&type=style&index=0&id=9373a9be&scoped=true&lang=css"
import "./PosTicket.vue?vue&type=style&index=1&id=9373a9be&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9373a9be"]])

export default __exports__